import React, { useEffect, useRef, useState } from "react";

import Icon from "../Icon/icon";
import Skeleton from "../Skeleton/skeleton";

import "./image.scss";

export const ImageComp = ({
  url,
  alt = "",
  onClick,
  placeholderComp,
  onError,
  onLoad,
  crossOrigin,
  className,
}) => {
  const [errored, setErrored] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const ref = useRef(null);

  const showPlaceholder = errored && placeholderComp;
  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      setLoaded(true);
      onLoad?.(ref.current);
    };
    img.onerror = () => {
      setErrored(true);
      onError?.();
    };
    if (crossOrigin) img.crossOrigin = crossOrigin;
    img.src = url;
  }, [url, onLoad, onError, crossOrigin]);

  return (
    <Icon
      className={`icon ${className}`}
      onClick={() => onClick?.()}
    >
      <img
        src={url}
        alt={alt}
        ref={ref}
        className={`image ${
          loaded ? "imageLoaded" : "imageHidden"
        }`}
        {...(crossOrigin ? { crossOrigin } : {})}
      />
      {showPlaceholder
        ? placeholderComp
        : !loaded && <Skeleton className="skeleton" />}
    </Icon>
  );
};
